/**
 * 腾讯域：广告命名模板 API 服务（CLAUDE.md §前端 API 服务层 — 按域分目录）。
 *
 * 类型统一定义在 types/adNameTemplate.types.ts（跨域共享，与后端 Pydantic 对齐），
 * 本文件只保留腾讯域的 HTTP 调用。
 */

import { request } from "../apiClient";
import type {
  AdNameTemplateRecord,
  SaveAdNameTemplateBody,
} from "../../types/adNameTemplate.types";

export async function getLatestTemplate(): Promise<AdNameTemplateRecord | null> {
  const data = await request<AdNameTemplateRecord | null>(
    "/api/v1/tencent/ad-name-template",
  );
  return data ?? null;
}

export async function saveTemplate(
  body: SaveAdNameTemplateBody,
): Promise<AdNameTemplateRecord> {
  return request<AdNameTemplateRecord>("/api/v1/tencent/ad-name-template", {
    method: "PUT",
    body,
  });
}

export async function deleteTemplate(templateId: string): Promise<void> {
  await request<unknown>(`/api/v1/tencent/ad-name-template/${templateId}`, {
    method: "DELETE",
  });
}
